import { Box, CircularProgress } from "@mui/material";
import { persistor, store } from "@store";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BaseOptionChartStyle } from "./components/chart/BaseOptionChart";
import { ConfirmModal } from "./components/common/ConfirmModal";
import PageLoader from "./components/common/PageLoader";
import initLanguages from "./lang";
import Router from "./routes";
import ThemeProvider from "./theme";

initLanguages();

/**
 * redux-persist localStorage'ı okuyana kadar gösterilir.
 * Bu olmadan Router boş bir store ile çalışır ve oturum açık olsa bile
 * her yenilemede /login'e yönlendirir.
 */
const BootstrapLoader = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
    }}
  >
    <CircularProgress />
  </Box>
);

export default function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <PersistGate loading={<BootstrapLoader />} persistor={persistor}>
          <SnackbarProvider>
            <PageLoader />
            <BaseOptionChartStyle />
            <Router />
            <ConfirmModal />
          </SnackbarProvider>
          <ToastContainer />
        </PersistGate>
      </ThemeProvider>
    </Provider>
  );
}
